import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LicenceService } from '../../../services/licence.service';
import {
  DriverLicenceEndorsement,
  DriverLicenceEntitlement,
  DriverLicenceRestriction,
  DriverLicenceSummary,
  LicenceStatus,
} from '../../../model/licence.model';
import { Observable } from 'rxjs';
import { CommonService } from '../../../services/common.service';

interface LicenceResultsModalData {
  pin: string;
  firstName: string;
  lastName: string;
}

@Component({
  selector: 'vrm-licence-results-modal',
  templateUrl: './licence-results-modal.component.html',
  styleUrls: ['./licence-results-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenceResultsModalComponent implements OnInit {
  protected title: string = null;
  protected printFileName: string = null;
  protected summary$: Observable<DriverLicenceSummary[]>;
  protected endorsements$: Observable<DriverLicenceEndorsement[]>;
  protected fullEntitlements$: Observable<DriverLicenceEntitlement[]>;
  protected provisionalEntitlements$: Observable<DriverLicenceEntitlement[]>;
  protected restrictionCodes$: Observable<DriverLicenceRestriction[]>;

  constructor(
    private licenceService: LicenceService,
    protected commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: LicenceResultsModalData
  ) {
    this.title = `${data.firstName} ${data.lastName} - ${data.pin}`;
    this.printFileName = this.determinePrintFileName();
  }

  public ngOnInit(): void {
    this.summary$ = this.licenceService.getSummary(this.data.pin);
    this.endorsements$ = this.licenceService.getEndorsements(this.data.pin);
    this.fullEntitlements$ = this.licenceService.getEntitlements(LicenceStatus.Full, this.data.pin);
    this.provisionalEntitlements$ = this.licenceService.getEntitlements(LicenceStatus.Provisional, this.data.pin);
    this.restrictionCodes$ = this.licenceService.getRestrictions();
  }

  private determinePrintFileName(): string {
    const date = new Date().toLocaleDateString();
    return `${this.data.firstName}_${this.data.lastName}_${this.data.pin}_licence-details_${date}`;
  }
}
